export const TYPE_EDIT = {
  ADD: "add object",
  REMOVE: "remove object",
};
